module.exports = __webpack_public_path__ + "b87eadce4bd6cbd17a4677035b3f086a.svg";